import React from 'react';
import Header from './Header';
import ProjectSelector from '../projects/ProjectSelector';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ProjectSelector />
        <main className="mt-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;